import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const newOpportunity = []

const state = {
  opportunityDetails: null,
  clientDetails: null,
  formatTypes: null,
  stepSelectData: null,
  permissionsData: null,
  newOpportunity,
  search: null,
  opportunity: null,
  opportunityBackup: null,
  day: null,
  isReorderingItinerary: false,
  opportunitiesSaved: null,
  sourceTypes: null,
  itinerarySourceTypeSelected: {
    index: 0
  },
  opportunitySource: null,
  signature: null
}

const opportunity = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default opportunity
